<template>
  <div id="app">
   <router-view  />

  </div>
</template>

<script>
import axios from 'axios';

import store from './store';
// import DesktopView from './views/Desktop.vue';


export default {
  data() {
    return {

    };
  },

  components: {

    /* DesktopView, */
  },

  async mounted() {
    try {
      const eventConfigRequestResult = await axios.get('/api/event', { responseType: 'json' });
      const eventConfigResult = eventConfigRequestResult.data;

      store.eventId = eventConfigResult.id;
      store.shortEventId = eventConfigResult.shortId;
      store.eventConfig = eventConfigResult.config;
      // console.log('Event config:', store.eventConfig);
    } catch (err) {
      console.error(err);
    }
  },
};
</script>

<style lang="scss">
html,
body {
  text-align: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

* {
    box-sizing: border-box;
}


.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}


.swal2-styled.swal2-confirm {
    background-color: #2fb9f1 !important;
    border: 0 !important;
}
.swal2-close,.swal2-close:focus{
  border:none !important;
   outline:none !important;
   box-shadow: none !important;
}


</style>
